var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenPolygonCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1124_26984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1744 5.81992C17.4442 5.31237 17.5015 4.71838 17.3336 4.1686C17.1656 3.61883 16.7863 3.15831 16.2791 2.88836C15.7718 2.61841 15.1782 2.56114 14.6287 2.72915C14.0793 2.89716 13.619 3.27668 13.3492 3.78423L6.5404 16.6007C6.42178 16.8232 6.35964 17.0714 6.35943 17.3235L6.36645 20.8207C6.36688 20.8901 6.38609 20.9581 6.42203 21.0174C6.45796 21.0768 6.50929 21.1253 6.57056 21.1579C6.63184 21.1904 6.70077 21.2057 6.77005 21.2022C6.83932 21.1987 6.90636 21.1765 6.96405 21.138L9.86655 19.1887C10.0753 19.0483 10.2464 18.8587 10.3649 18.6367L17.1744 5.81992Z",
    stroke: "white",
    strokeWidth: 1.53744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1124_26984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4448,
    height: 18.4537,
    fill: "white",
    transform: "matrix(0.956257 -0.292528 0.292216 0.956352 0.0859375 5.56738)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenPolygonCorner);
export default __webpack_public_path__ + "static/media/pen-polygon-corner.396cd2ef69210b1a0af09bc9e06e8e92.svg";
export { ForwardRef as ReactComponent };